import React, {useEffect, useState} from 'react'
import VeranstalterVerwaltenDialog from "./VeranstalterVerwaltenDialog";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ConfirmDialog from "../../general/ConfirmDialog";
import PropTypes from "prop-types";
import {Navigate} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../constants/navigationItems";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHButtonIconDelete from "../../general/DHButtonIconDelete";
import DHButtonIconPencil from "../../general/DHButtonIconPencil";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHIconAdd from "../../general/DHIconAdd";

function VeranstalterVerwalten({onSave}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    let [goToDashboard, setGoToDashboard] = useState(false);
    let [showDeleteDialog, setShowDeleteDialog] = useState(false);
    let [showDialog, setShowDialog] = useState(false);
    let [veranstalterListe, setVeranstalterListe] = useState([]);
    let [selectedVeranstalter, setSelectedVeranstalter] = useState(false);

    useEffect(() => {
        load();
    }, []);


    const loescheVeranstalter = () => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.eventoperator + "/loesche/" + selectedVeranstalter.id,
            {},
            () => {
                setShowDeleteDialog(false);
                load();
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Löschen: " + responseNotOk.message);
                setShowDeleteDialog(false);
            },
            error => {
                setErrorMessage("Fehler beim Löschen: " + error.message);
                setShowDeleteDialog(false);
            });
    }

    const load = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.eventoperator + "/byCurrentUser",
            json => {
                setVeranstalterListe(json);
            },
            responseNotOk => {
                showError("Fehler beim Laden: " + responseNotOk.message);
            },
            error => {
                showError("Fehler beim Laden: " + error.message);
            });
    }

    const rows = () => {
        let tmp = [];
        for (const veranstalter of veranstalterListe) {
            tmp.push(<div key={"key_veranstalter_" + veranstalter.id}>
                    <hr/>
                    <div className="grid" style={{
                        alignItems: "center",
                        height: 80,
                        margin: 20
                    }}>
                        <div className="col">
                            <div style={{justifyContent: "left", alignItems: "center", display: "flex", fontSize: 30}}>
                                <span style={{marginRight:20}}>
                                    <DHButtonIconPencil onClick={() => {
                                        setSelectedVeranstalter(veranstalter);
                                        setShowDialog(true);
                                    }} />
                                    <DHButtonIconDelete onClick={() => {
                                        setSelectedVeranstalter(veranstalter);
                                        setShowDeleteDialog(true);
                                    }} />
                                </span>
                                {veranstalter.name}
                            </div>
                            <div style={{fontSize:16, marginTop:10}}>
                                Id: {veranstalter.idShort}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return tmp;
    }

    if (goToDashboard) {
        return <Navigate to={NAVIGATION_ITEM.DASHBOARD.route}/>;
    }

    return <div>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)} />
        <div>
            <DHButtonDefault onClick={() => {
                setShowDialog(true);
                setSelectedVeranstalter(undefined);
            }} label="Neuen Veranstalter anlegen" icon={<DHIconAdd/>} />
        </div>
        <div style={{marginTop:20, marginBottom:10, fontSize:20}}>
            Hinweis: Mehrere Veranstalter sind nicht notwendig, wenn du nur unterschiedliche Turniere spielen willst. Lege mehrere Veranstalter nur an, wenn du für mehrere Vereine oder Veranstalter Turniere oder Ligen durchführen möchtest.
        </div>
        {rows()}
        {showDialog && <VeranstalterVerwaltenDialog eventOperatorID={selectedVeranstalter !== undefined ? selectedVeranstalter.id : undefined} onClose={() => setShowDialog(false)} onSave={() => {
            load();
            onSave();
        }}/>}
        {showDeleteDialog &&<ConfirmDialog visible={true}
                                    callBackOnNein={() => setShowDeleteDialog(false)}
                                    callBackOnJa={() => loescheVeranstalter()}
                                    header="Veranstalter Löschen"
                                    textOben="Du verlierst evtl. deinen Pro-Veranstalter Account und hast keinen Zugriff mehr auf Turniere und Ligen dieses Veranstalters."
                                    textUnten="Möchtest du den Veranstalter wirklich löschen?"/>}
    </div>
}

VeranstalterVerwalten.propTypes = {
    onSave: PropTypes.func.isRequired,
};

export default VeranstalterVerwalten;
